/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointthree1Inputs */

const ja_home_agency_pointthree1 = /** @type {(inputs: Home_Agency_Pointthree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東京を拠点に、国内外の多様なパートナー企業と連携し、ゲーマーに企業ブランドの魅力を効果的に伝えるマーケティング活動を展開しています。`)
};

const en_home_agency_pointthree1 = /** @type {(inputs: Home_Agency_Pointthree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based in Tokyo, we work with foreign Brands in Japan and Japanese Brands around the World.`)
};

/**
* | output |
* | --- |
* | "Based in Tokyo, we work with foreign Brands in Japan and Japanese Brands around the World." |
*
* @param {Home_Agency_Pointthree1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointthree1 = /** @type {((inputs?: Home_Agency_Pointthree1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointthree1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointthree1(inputs)
	return en_home_agency_pointthree1(inputs)
});
export { home_agency_pointthree1 as "home_agency_pointThree" }